import { iso6392,Language } from 'iso-639-2';
import {iso31661} from "iso-3166";
import { Timestamp } from "firebase/firestore";
import { format } from "date-fns";

export const  capitalizeFirstLetter = (str: string): string => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export const isStringEmpty = (str: string | null | undefined): boolean => {
    return !str || str.length === 0;
}

export const getLanguageName = (code: string) => {
    const language = Object.values(iso6392).find((lang) => {
      const langData = lang as Language;
      return langData.iso6392B === code || langData.iso6392T === code || langData.iso6391 === code;
    }) as Language | undefined;
    return language ? language.name : 'Unknown';
};

export const getCountryName = (code: string) => {
    const country = iso31661.find(
      (country) =>
        country.alpha2 === code.toUpperCase() ||
        country.alpha3 === code.toUpperCase() ||
        country.numeric === code
    );
    return country ? country.alpha3 : 'Unknown';
};

export const generateUUID = () => {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
  
    return Array.from(array)
    .map((b, i) =>
      (i === 6 ? (b & 0x0f) | 0x40 : i === 8 ? (b & 0x3f) | 0x80 : b)
        .toString(16)
        .padStart(2, '0')
    )
    .join('');
};

export function formatAttributeValue(value: any): React.ReactNode {
  if (value instanceof Timestamp) {
    return format(value.toDate(), "MMM, dd yyyy"); // or any formatting
  }
  if (value === null || value === undefined) return ''; // or a dash '-'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value.toString(); // string, number, etc.
}

export function pluralize(count: number, singular: string, plural?: string): string {
  const label = count === 1 ? singular : (plural ?? singular + 's');
  return `${count} ${label}`;
}

export function removeUndefined<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== undefined)
  ) as Partial<T>;
}

export function normalizeURL(url: string) {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}